<template>
  <div class="wrap">
    <div class="main">
      <div class="title">考试成绩</div>
      <div class="line"></div>

      <div class="exam-table">
        <div class="exam-table-header">
          <div class="table-td">序号</div>
          <div class="table-td">开始时间</div>
          <div class="table-td">考试状态</div>
          <div class="table-td">考试分数</div>
          <div class="table-td">考试结果</div>
        </div>
        <div class="exam-table-body">
          <template v-if="!list.length">
            <div class="table-line-no-item">暂无考试信息</div>
          </template>
          <template v-else>
            <div class="table-line" v-for="(item, index) in list" :key="index">
              <div class="table-body-td">{{ index + 1 }}</div>
              <div class="table-body-td">{{ item.created_at }}</div>
              <div class="table-body-td">{{ item.status | filterStatus }}</div>
              <div class="table-body-td">
                {{ item.status === 2 ? item.score : "-" }}
              </div>
              <div class="table-body-td">
                {{ item.status === 2 ? item.score>= ExamPassedScore ?'已通过':'未通过':'-' }}
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="exam-start" @click="clickGoExam">开始考试</div>
    </div>
  </div>
</template>
<script>
import { fetchExamList, fetchAddExam } from "@/api/exam";
import { ExamStatusEnum, ExamPassedScore } from "@/utils/enum";
export default {
  name: "ExamList",
  data() {
    return {
      list: [],
      ExamPassedScore:0
    };
  },
  filters: {
    filterStatus(val) {
      if (typeof val === "number") {
        return ExamStatusEnum[val];
      } else {
        return "";
      }
    },
    filterPass(status, val) {
      if (status === 2) {
        if (val >= ExamPassedScore) {
          return "通过";
        } else {
          return "不通过";
        }
      } else {
        return "-";
      }
    }
  },
  methods: {
    async clickGoExam() {
      let res = await fetchAddExam();
      const { data } = res;
      const { answer } = data;
      const { id } = answer;

      this.$router.push({
        name: "Exam",
        query: {
          id
        }
      });
    }
  },
  mounted() {
    fetchExamList({
      page: 1,
      page_size: 100
    }).then((res) => {
      const { data } = res;
      this.list = data.data;
    });
    this.ExamPassedScore = ExamPassedScore
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
